export const hasCoordinates = (location = {}) =>
  Number.isFinite(location.latitude) && Number.isFinite(location.longitude);
